import { Rect } from './styled';
export function CustomBar(props) {
    const { fill, x, y, width, height, stroke } = props;
    return (<Rect x={x} y={y} width={width} height={height} fill={fill} rx={5} ry={5} stroke={stroke}/>);
}
